import { NgModule } from '@angular/core';
import { LanguageSwitcherModule } from 'src/core/components/language-switcher/modules/language-switcher.module';
import { WelcomeModule } from 'src/core/components/welcome/welcome.module';
import { CoreModule } from 'src/core/modules/core.Module';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderMenuComponent } from '../components/header-menu/header-menu.component';

@NgModule({
  declarations: [
    HeaderMenuComponent
  ],
  imports: [
    CoreModule,
    LanguageSwitcherModule,
    WelcomeModule,
    TranslateModule
  ]
})
export class HeaderMenuModule { }
